var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    [
      _c(
        "vs-tabs",
        [
          _c(
            "vs-tab",
            { attrs: { label: _vm.$t("document_title_document") } },
            [_c("form-document", { attrs: { id: _vm.id } })],
            1
          ),
          _vm.id
            ? _c(
                "vs-tab",
                { attrs: { label: _vm.$t("document_destination") } },
                [_c("form-document-destination", { attrs: { id: _vm.id } })],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }